@if (!hideHeader) {
  <side-panel-header
    [displayText]="labelsAndNotesLabel"
    [showBorder]="showSectionHeaderBorder"
  ></side-panel-header>
}
@for (section of sections; track section) {
  <section class="SidePanelLabelsAndNotes__Section">
    <section class="SidePanelLabelsAndNotes__Card">
      <ng-container
        body
        [ngTemplateOutlet]="
          section.showButton
            ? AddButton
            : section.key === 'labels'
              ? Labels
              : Notes
        "
        [ngTemplateOutletContext]="{ section: section }"
      >
        @if (section.key === 'labels' && labelsErrorMessage) {
          <p
            class="SidePanelLabelsAndNotes__Section--errors"
            [innerHTML]="labelsErrorMessage"
          ></p>
        }
        @if (section.key === 'notes' && notesErrorMessage) {
          <p
            class="SidePanelLabelsAndNotes__Section--errors"
            [innerHTML]="notesErrorMessage"
          ></p>
        }
      </ng-container>
    </section>
    <!--        OUTPUT TEMPLATES       -->
    <!-- Show Labels If Available -->
    <ng-template #Labels let-link="section">
      <ng-container
        [ngTemplateOutlet]="Header"
        [ngTemplateOutletContext]="{ section: section }"
      ></ng-container>
      <div class="SidePanelLabelsAndNotes__LabelsPillsWrapper">
        @for (label of link.data; track label) {
          <status
            class="SidePanelLabelsAndNotes__LabelsPill"
            [config]="{ label: label, status: 'info' }"
          ></status>
        }
      </div>
    </ng-template>
    <!-- Show Notes If Available -->
    <ng-template #Notes let-link="section">
      @if (!showEditNotesButtonAtBottom) {
        <ng-container
          [ngTemplateOutlet]="Header"
          [ngTemplateOutletContext]="{ section: section }"
        ></ng-container>
      }
      <p class="SidePanelLabelsAndNotes__Notes" [innerHTML]="link.data"></p>
      @if (showEditNotesButtonAtBottom) {
        <ng-container
          [ngTemplateOutlet]="Footer"
          [ngTemplateOutletContext]="{ section: section }"
        ></ng-container>
      }
    </ng-template>
    <!--       Shared Content        -->
    <!-- Add Button -->
    <ng-template #AddButton let-link="section">
      <zip-button
        (zipButtonClicked)="handleAddNew(link.key)"
        [config]="buttonConfigs[link.key]"
        [ariaDescription]="'Add ' + link.key"
      >
      </zip-button>
    </ng-template>
    <!-- Header -->
    <ng-template #Header let-link="section">
      <p class="SidePanelLabelsAndNotes__SectionHeader">
        <span class="SidePanelLabelsAndNotes__SubtitleInfo">
          <span class="t-bold">{{ link.title }}</span>
          @if (!link.hideInfoIcon) {
            <icon
              class="SidePanelLabelsAndNotes__Icon--info"
              name="info"
              [config]="{ format: 'svg', type: 'link', size: 'small' }"
              (click)="handleInfo(link.key)"
            ></icon>
          }
        </span>
        <icon
          name="edit"
          [config]="{
            format: 'svg',
            type: 'link',
            size: 'medium',
          }"
          (click)="handleEdit(link.key)"
        ></icon>
      </p>
    </ng-template>
    <ng-template #Footer let-link="section">
      <p
        data-test-id="NotesSectionFooter"
        class="SidePanelLabelsAndNotes__SectionFooter"
        (click)="handleEdit(link.key)"
      >
        <icon
          name="edit"
          class="SidePanelLabelsAndNotes__SectionFooter--Icon"
          [config]="mediumLinkIconConfig"
          data-test-id="NotesSectionFooterIcon"
        ></icon>
        <span class="SidePanelLabelsAndNotes__SubtitleInfo">
          <span
            [innerHtml]="link.title"
            data-test-id="NotesSectionSubTitle"
          ></span>
          @if (!link.hideInfoIcon) {
            <icon
              class="SidePanelLabelsAndNotes__Icon--info"
              name="info"
              [config]="smallLinkIconConfig"
              (click)="handleInfo(link.key)"
              data-test-id="NotesSectionInfoIcon"
            ></icon>
          }
        </span>
      </p>
    </ng-template>
  </section>
}
<side-panel-info-modal
  [(showInfo)]="infoIsShowing"
  [whichInfo]="infoKey"
></side-panel-info-modal>
